import { render, staticRenderFns } from "./Flatbed.vue?vue&type=template&id=63a114aa&scoped=true"
import script from "./Flatbed.vue?vue&type=script&lang=js"
export * from "./Flatbed.vue?vue&type=script&lang=js"
import style0 from "./Flatbed.vue?vue&type=style&index=0&id=63a114aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a114aa",
  null
  
)

export default component.exports